import { render, staticRenderFns } from "./vessel.vue?vue&type=template&id=055bb46b&scoped=true&"
import script from "./vessel.vue?vue&type=script&lang=js&"
export * from "./vessel.vue?vue&type=script&lang=js&"
import style0 from "./vessel.vue?vue&type=style&index=0&id=055bb46b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "055bb46b",
  null
  
)

export default component.exports